// NodeBooleanField.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './NodeBooleanField.css';

// Components
import Checkbox from 'components/checkbox/Checkbox';
import { coerceBooleanFieldValue } from 'utilities/NodeFieldCoercion';

/**
 * Schema boolean field. In readOnly / previewMode: show checked state, no toggle.
 *
 * @param {string} [fieldLabel] - Optional label passed through to Checkbox.
 * @param {*} value - Current field value.
 * @param {Function} [onChange] - Toggle callback.
 * @param {boolean} [readOnly=false] - Display-only; no toggle.
 * @param {boolean} [previewMode=false] - Alias for readOnly (NodeField visitor path).
 *
 * @returns {ReactNode}
 */
const NodeBooleanField = ({
  fieldLabel,
  value,
  onChange,
  readOnly = false,
  previewMode = false,
}) => {
  const { theme } = useTheme();
  const isReadOnly = Boolean(readOnly || previewMode);
  const checked = coerceBooleanFieldValue(value);

  return (
    <div className="node-boolean-field-container">
      <div
        className={[
          'node-boolean-field-checkbox',
          isReadOnly ? 'node-boolean-field-checkbox--readonly' : '',
        ].filter(Boolean).join(' ')}
      >
        <Checkbox
          color={theme.foregroundMuted}
          value={checked}
          size="28"
          label={fieldLabel ? '' : undefined}
          fontSize="16px"
          onChange={isReadOnly ? undefined : () => onChange?.(!checked)}
        />
      </div>
    </div>
  );
};

NodeBooleanField.displayName = 'NodeBooleanField';

export default NodeBooleanField;
